import script from "./XPageLayout.vue?vue&type=script&lang=tsx"
export * from "./XPageLayout.vue?vue&type=script&lang=tsx"

import "./XPageLayout.vue?vue&type=style&index=0&id=ba54a60a&lang=less&scoped=true"
script.__scopeId = "data-v-ba54a60a"

export default script